import moment from 'moment';

/**
 * @param {number} index
 * @param {string} selectedTime
 * @param {(e: *, val: number) => void} onInputChange
 * @param {string} shiftStartTime
 * @param {string} shiftEndTime
 * @param {number[]} slideValue
 */
export const handleTextInputChange = (index, selectedTime, onInputChange, shiftStartTime, shiftEndTime, sliderValue) => {
    if (selectedTime) {
        const values = selectedTime.split(':');
        if (values.length === 2 && values[0] !== '' && values[1] !== '') {
            const hrs = parseInt(values[0], 10);
            const mins = Math.floor(parseInt(values[1], 10) / 15) * 0.25;
            const closestTime = hrs + mins;

            //Calculate minutes between selected time and shift start time    
            const shiftStartDate = moment.utc(shiftStartTime);
            const shiftEndDate = moment.utc(shiftEndTime);

            const startOfDay = shiftStartDate.clone().startOf('day');
            let selectedTimeOfDay = startOfDay.clone().add(closestTime, 'hours');
            if (selectedTimeOfDay < shiftStartDate) {
                while (selectedTimeOfDay < shiftStartDate) {// Have to guess which day the selected time corresponds to
                    selectedTimeOfDay = selectedTimeOfDay.add(1, 'd');//add 24 hours
                    if (selectedTimeOfDay > shiftEndDate) {
                        //error - selected date is smaller than startDate and bigger than endDate
                        selectedTimeOfDay = shiftStartDate;
                        break;
                    }
                }
            } else if (selectedTimeOfDay > shiftEndDate){
                selectedTimeOfDay = shiftEndDate;
            }

            const minutesFromShiftStartDate = selectedTimeOfDay.diff(shiftStartDate, 'minutes');

            if (minutesFromShiftStartDate >= 0 && minutesFromShiftStartDate <= 24 * 60) {
                const updatedValue = [...sliderValue];
                updatedValue[index] = minutesFromShiftStartDate;
                
                if (updatedValue[0] <= updatedValue[1]) {
                    onInputChange(null, updatedValue);
                }
            }
        }
    }
};